import React, { Component } from "react";
import Select from "react-select";
import {
  ListaProdutividadeDetalhada,
  ListaVendedoresAtivos,
  runVerificaAutenticacao,
  ListaTelasCRM,
} from "../../../services/api";
import $ from "jquery";
import Moment from "moment";
import Header from "../../../components/Header";
import {
  ButtonSelect,
  ContentFilterSelect,
  ContentGrid,
  ContentGridLoading,
  ContentGridLoadingContent,
  ContentGridTable,
  FilterContainer,
  LabelData,
  ProdutividadeDetalhadaContainer,
  ProdutividadeDetalhadaContainerText,
  SelectBox,
  SelectVendedorProdutividade,
} from "./styles";
import { Image, Text } from "@chakra-ui/react";

const loading = "/images/loading.gif";

class ProdutividadeDetalhada extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dados: [],
      totais: [],
      vendedores: [],
      data_de_selecionada: null,
      data_ate_selecionada: null,
      linha_selecionada: [],
      vendedor_selecionado: null,

      codigo_usuario: JSON.parse(localStorage.getItem("authentication"))
        .codigo_usuario,
      codigo_vendedor: JSON.parse(localStorage.getItem("authentication"))
        .codigo_vendedor,

      control_inclusao: null,
      control_alteracao: null,
      control_exclusao: null,
      control_consulta: null,
    };
  }

  componentDidMount() {
    runVerificaAutenticacao();
    this.initial();
  }

  initial = async () => {
    await this.CarregaPermissoes();
    if ([0, 30, 22, 21, 14, 12].includes(this.state.codigo_usuario)) {
      this.getConfig();
    } else {
      this.getVendedores();
      this.getLessons();
    }
  };

  getConfig = async () => {
    const queryParams = new URLSearchParams(window.location.search);

    const vendedor = queryParams.get("v");

    await this.getVendedores();

    if (vendedor != null) {
      console.log(vendedor);
      $("#selectVendedor").val(vendedor);
      await this.setState({ vendedor_selecionado: vendedor });
    }

    this.getLessons();
  };

  CarregaPermissoes = async () => {
    try {
      const response = await ListaTelasCRM.get(
        "/" + window.location.pathname.replace("/", "")
      );
      var data = response.data;

      var codigo_tela = null;
      for (var obj in data) {
        codigo_tela = obj;
      }

      this.setState({
        codigo_tela: codigo_tela,
        control_inclusao: JSON.parse(localStorage.getItem("authentication"))
          .permissoes_usuario[codigo_tela].inclusao,
        control_alteracao: JSON.parse(localStorage.getItem("authentication"))
          .permissoes_usuario[codigo_tela].alteracao,
        control_exclusao: JSON.parse(localStorage.getItem("authentication"))
          .permissoes_usuario[codigo_tela].exclusao,
        control_consulta: JSON.parse(localStorage.getItem("authentication"))
          .permissoes_usuario[codigo_tela].consulta,
      });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  selecionaLinha = async (e) => {
    var value = parseInt(e.nativeEvent.path[1].attributes.id.value);

    if (this.state.linha_selecionada.includes(value)) {
      var linha_selecionada = [];
      this.state.linha_selecionada.map((data) => {
        if (data != value) {
          linha_selecionada.push(data);
        }
      });
      this.setState({ linha_selecionada: linha_selecionada });
    } else {
      var linha_selecionada = this.state.linha_selecionada;
      linha_selecionada.push(value);
      this.setState({ linha_selecionada: linha_selecionada });
    }

    console.log(value);
    console.log(this.state.linha_selecionada);
    console.log(this.state.linha_selecionada.includes(value));
  };

  getVendedores = async () => {
    try {
      const response = await ListaVendedoresAtivos.get();
      var data = response.data;

      var vendedores = [];
      data.map((data) => {
        vendedores.push({
          value: data.codigo_usuario,
          label: data.nome_vendedor,
        });
      });

      this.setState({ vendedores: vendedores });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getLessons = async () => {
    if (this.state.control_consulta != "S") {
      alert("Permissão negada");
      return false;
    }

    try {
      this.setState({ dados: [], totais: [], loading: true });

      var param = {
        codigo_vendedor:
          this.state.vendedor_selecionado == null
            ? this.state.codigo_usuario
            : this.state.vendedor_selecionado,
        data_de: this.state.data_de_selecionada,
        data_ate: this.state.data_ate_selecionada,
      };
      const response = await ListaProdutividadeDetalhada.post("", param);
      var data = response.data;
      var totais = data[data.length - 1];

      data.pop();
      this.setState({
        dados: data,
        totais: totais,
        loading: false,
      });
    } catch (error) {
      this.setState({
        dados: [],
        totais: [],
        loading: false,
      });
      console.log(Object.keys(error), error.message);
    }
  };

  changeInputField = async (elem, type, field) => {
    if (type == "select") {
      this.setState({
        [field]: elem.target.options[elem.target.options.selectedIndex].value,
      });
    } else if (type == "input") {
      this.setState({ [field]: elem.target.value });
    }
  };

  render() {
    const { dados, totais, vendedores, linha_selecionada } = this.state;
    return (
      <>
        <ProdutividadeDetalhadaContainer>
          <ProdutividadeDetalhadaContainerText>
            <h1>
              DETALHAMENTO DE <strong>PRODUTIVIDADE</strong>
            </h1>
          </ProdutividadeDetalhadaContainerText>
        </ProdutividadeDetalhadaContainer>
        <FilterContainer>
          {[0, 30, 22, 21, 14, 12].includes(this.state.codigo_usuario) ? (
            <SelectVendedorProdutividade>
              <SelectBox
                bgColor="white"
                color="gray.500"
                iconColor="#76A5D7"
                fontSize="20px"
                variant="outline"
                focusBorderColor="#76A5D7"
                _hover={{ borderBottomColor: "#76A5D7" }}
                _active={{ borderBottomColor: "#76A5D7" }}
                placeholder="Vendedores..."
                id="selectVendedor"
                onChange={(e) =>
                  this.changeInputField(e, "select", "vendedor_selecionado")
                }
              >
                {vendedores.map((data) => {
                  return <option value={data.value}>{data.label}</option>;
                })}
              </SelectBox>
            </SelectVendedorProdutividade>
          ) : (
            <></>
          )}
          {/* {[0, 30,22,21,14,12].includes(this.state.codigo_usuario) ? 
                        <div className="innovation-crm-produtividade-detalhada-container__content__filter__selector">
                            <Select
                                className='innovation-crm-status-pedido-container__content__filter__selector__label__status'
                                placeholder="Vendedor"
                                options={this.state.vendedores}
                                id="selectVendedor"
                                onChange={(e)=>this.changeInputField(e,'select','vendedor_selecionado')}
                            />
                        </div> : <div></div>
                    } */}

          <ContentFilterSelect>
            <label for="">De:</label>
            <input
              name="dataEnd"
              type="date"
              onChange={(e) =>
                this.changeInputField(e, "input", "data_de_selecionada")
              }
            />
          </ContentFilterSelect>
          <ContentFilterSelect>
            <label for="">Até:</label>
            <input
              name="dataEnd"
              type="date"
              onChange={(e) =>
                this.changeInputField(e, "input", "data_ate_selecionada")
              }
            />
          </ContentFilterSelect>

          <ButtonSelect
            bgColor="#76A5D7"
            color="#fff"
            _hover={{ bgColor: "#76A5D7" }}
            onClick={() => this.getLessons()}
          >
            Filtrar
          </ButtonSelect>
        </FilterContainer>
        <ContentGrid>
          {this.state.loading ? (
            <ContentGridLoading>
              <ContentGridLoadingContent>
                <Image alt="loading" src={loading}></Image>
              </ContentGridLoadingContent>
            </ContentGridLoading>
          ) : (
            <></>
          )}
          <ContentGridTable>
            <table>
              <thead>
                <th>
                  <div>
                    <p>Data</p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Ligações
                      <br />
                      Efetuadas
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Ligações
                      <br />
                      Recebidas
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Propostas
                      <br />
                      Encaminhadas
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Pedidos
                      <br />
                      Finalizados
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Solicitações
                      <br />
                      de Layout
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Layouts
                      <br />
                      Respondidos
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      E-mails
                      <br />
                      Encaminhados
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Propostas
                      <br />
                      Perdidas
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Novos
                      <br />
                      Chamados Site
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Novos Chamados
                      <br />
                      Whatsapp
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Novos Chamados
                      <br />
                      Vendedor
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Novos Chamados
                      <br />
                      Atendimento
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Ticket
                      <br />
                      Médio
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>VENDAS DO DIA</p>
                  </div>
                </th>
              </thead>
              <tbody>
                {dados.map((data, idx) => {
                  return (
                    <tr>
                      <td>
                        <div
                          style={
                            linha_selecionada.includes(idx + 1)
                              ? { backgroundColor: "#3aa7de", color: "white" }
                              : {}
                          }
                          id={idx + 1}
                          onClick={(e) => this.selecionaLinha(e)}
                        >
                          <p
                            style={
                              linha_selecionada.includes(idx + 1)
                                ? { backgroundColor: "#3aa7de", color: "white" }
                                : {}
                            }
                          >
                            {Moment(data.data_negociada).format("DD/MM/YYYY")}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          style={
                            linha_selecionada.includes(idx + 1)
                              ? { backgroundColor: "#3aa7de", color: "white" }
                              : {}
                          }
                          id={idx + 1}
                          onClick={(e) => this.selecionaLinha(e)}
                        >
                          <p
                            style={
                              linha_selecionada.includes(idx + 1)
                                ? { backgroundColor: "#3aa7de", color: "white" }
                                : {}
                            }
                          >
                            {data.chamada_efetuada}
                          </p>
                          <p
                            style={
                              linha_selecionada.includes(idx + 1)
                                ? { backgroundColor: "#3aa7de", color: "white" }
                                : {}
                            }
                          >
                            {data.chamada_duracao_efeturada}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          style={
                            linha_selecionada.includes(idx + 1)
                              ? { backgroundColor: "#3aa7de", color: "white" }
                              : {}
                          }
                          id={idx + 1}
                          onClick={(e) => this.selecionaLinha(e)}
                        >
                          <p
                            style={
                              linha_selecionada.includes(idx + 1)
                                ? { backgroundColor: "#3aa7de", color: "white" }
                                : {}
                            }
                          >
                            {data.chamada_recebida}
                          </p>
                          <p
                            style={
                              linha_selecionada.includes(idx + 1)
                                ? { backgroundColor: "#3aa7de", color: "white" }
                                : {}
                            }
                          >
                            {data.chamada_duracao_recebida}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          style={
                            linha_selecionada.includes(idx + 1)
                              ? { backgroundColor: "#3aa7de", color: "white" }
                              : {}
                          }
                          id={idx + 1}
                          onClick={(e) => this.selecionaLinha(e)}
                        >
                          <p
                            style={
                              linha_selecionada.includes(idx + 1)
                                ? { backgroundColor: "#3aa7de", color: "white" }
                                : {}
                            }
                          >
                            {data.propostas_encaminhadas}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          style={
                            linha_selecionada.includes(idx + 1)
                              ? { backgroundColor: "#3aa7de", color: "white" }
                              : {}
                          }
                          id={idx + 1}
                          onClick={(e) => this.selecionaLinha(e)}
                        >
                          <p
                            style={
                              linha_selecionada.includes(idx + 1)
                                ? { backgroundColor: "#3aa7de", color: "white" }
                                : {}
                            }
                          >
                            {data.pedidos_finalizados}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          style={
                            linha_selecionada.includes(idx + 1)
                              ? { backgroundColor: "#3aa7de", color: "white" }
                              : {}
                          }
                          id={idx + 1}
                          onClick={(e) => this.selecionaLinha(e)}
                        >
                          <p
                            style={
                              linha_selecionada.includes(idx + 1)
                                ? { backgroundColor: "#3aa7de", color: "white" }
                                : {}
                            }
                          >
                            {data.solicitacao_layout}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          style={
                            linha_selecionada.includes(idx + 1)
                              ? { backgroundColor: "#3aa7de", color: "white" }
                              : {}
                          }
                          id={idx + 1}
                          onClick={(e) => this.selecionaLinha(e)}
                        >
                          <p
                            style={
                              linha_selecionada.includes(idx + 1)
                                ? { backgroundColor: "#3aa7de", color: "white" }
                                : {}
                            }
                          >
                            {data.layout_respondidos}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          style={
                            linha_selecionada.includes(idx + 1)
                              ? { backgroundColor: "#3aa7de", color: "white" }
                              : {}
                          }
                          id={idx + 1}
                          onClick={(e) => this.selecionaLinha(e)}
                        >
                          <p
                            style={
                              linha_selecionada.includes(idx + 1)
                                ? { backgroundColor: "#3aa7de", color: "white" }
                                : {}
                            }
                          >
                            {data.emails_encaminhados}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          style={
                            linha_selecionada.includes(idx + 1)
                              ? { backgroundColor: "#3aa7de", color: "white" }
                              : {}
                          }
                          id={idx + 1}
                          onClick={(e) => this.selecionaLinha(e)}
                        >
                          <p
                            style={
                              linha_selecionada.includes(idx + 1)
                                ? { backgroundColor: "#3aa7de", color: "white" }
                                : {}
                            }
                          >
                            {data.propostas_perdidas}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          style={
                            linha_selecionada.includes(idx + 1)
                              ? { backgroundColor: "#3aa7de", color: "white" }
                              : {}
                          }
                          id={idx + 1}
                          onClick={(e) => this.selecionaLinha(e)}
                        >
                          <p
                            style={
                              linha_selecionada.includes(idx + 1)
                                ? { backgroundColor: "#3aa7de", color: "white" }
                                : {}
                            }
                          >
                            {data.novos_chamados_site}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          style={
                            linha_selecionada.includes(idx + 1)
                              ? { backgroundColor: "#3aa7de", color: "white" }
                              : {}
                          }
                          id={idx + 1}
                          onClick={(e) => this.selecionaLinha(e)}
                        >
                          <p
                            style={
                              linha_selecionada.includes(idx + 1)
                                ? { backgroundColor: "#3aa7de", color: "white" }
                                : {}
                            }
                          >
                            {data.novos_chamados_whatsapp}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          style={
                            linha_selecionada.includes(idx + 1)
                              ? { backgroundColor: "#3aa7de", color: "white" }
                              : {}
                          }
                          id={idx + 1}
                          onClick={(e) => this.selecionaLinha(e)}
                        >
                          <p
                            style={
                              linha_selecionada.includes(idx + 1)
                                ? { backgroundColor: "#3aa7de", color: "white" }
                                : {}
                            }
                          >
                            {data.novos_chamados_vendedor}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          style={
                            linha_selecionada.includes(idx + 1)
                              ? { backgroundColor: "#3aa7de", color: "white" }
                              : {}
                          }
                          id={idx + 1}
                          onClick={(e) => this.selecionaLinha(e)}
                        >
                          <p
                            style={
                              linha_selecionada.includes(idx + 1)
                                ? { backgroundColor: "#3aa7de", color: "white" }
                                : {}
                            }
                          >
                            {data.novos_chamados_atendimento}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          style={
                            linha_selecionada.includes(idx + 1)
                              ? { backgroundColor: "#3aa7de", color: "white", fontWeight: "bold", }
                              : {}
                          }
                          id={idx + 1}
                          onClick={(e) => this.selecionaLinha(e)}
                        >
                          <Text
                            style={
                              linha_selecionada.includes(idx + 1)
                                ? {
                                  fontWeight: "bold",
                                    backgroundColor: "#3aa7de",
                                    color: "white",
                                    textAlign: "left",
                                    paddingLeft: "1rem",                                    
                                  }
                                : { textAlign: "left", paddingLeft: "1rem", fontWeight: "bold", }
                            }
                          >
                            R${" "}
                            {data.pedidos_finalizados > 0
                              ? (
                                  parseFloat(data.vendas_do_dia) /
                                  data.pedidos_finalizados
                                ).toLocaleString("pt-br", {
                                  minimumFractionDigits: 2,
                                })
                              : "0,00"}
                          </Text>
                        </div>
                      </td>
                      <td>
                        <div
                          style={
                            ({ textAlign: "left" },
                            linha_selecionada.includes(idx + 1)
                              ? { backgroundColor: "#3aa7de", color: "white", fontWeight: "bold", }
                              : {})
                          }
                          id={idx + 1}
                          onClick={(e) => this.selecionaLinha(e)}
                        >
                          <Text
                            style={
                              linha_selecionada.includes(idx + 1)
                                ? {
                                    backgroundColor: "#3aa7de",
                                    color: "white",
                                    textAlign: "left",
                                    paddingLeft: "1rem",
                                    fontWeight: "bold",
                                  }
                                : { textAlign: "left", paddingLeft: "1rem", fontWeight: "bold", }
                            }
                          >
                            R${" "}
                            <strong>
                              {parseFloat(data.vendas_do_dia).toLocaleString(
                                "pt-br",
                                { minimumFractionDigits: 2 }
                              )}
                            </strong>
                          </Text>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <th>
                  <div>
                    <p></p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Total
                      <br />
                      {totais.chamada_efetuada_total} -{" "}
                      {totais.chamada_efetuada_duracao_total}{" "}
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Total
                      <br />
                      {totais.chamada_recebida_total} -{" "}
                      {totais.chamada_recebida_duracao_total}{" "}
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Total
                      <br />
                      {totais.propostas_encaminhadas}
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Total
                      <br />
                      {totais.pedidos_finalizados}
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Total
                      <br />
                      {totais.solicitacao_layout}
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Total
                      <br />
                      {totais.layout_respondidos}
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Total
                      <br />
                      {totais.emails_encaminhados}
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Total
                      <br />
                      {totais.propostas_perdidas}
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Total
                      <br />
                      {totais.novos_chamados_site}
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Total
                      <br />
                      {totais.novos_chamados_whatsapp}
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Total
                      <br />
                      {totais.novos_chamados_vendedor}
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Total
                      <br />
                      {totais.novos_chamados_atendimento}
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      Total
                      <br />
                      RS{" "}
                      <strong>
                        {(
                          parseFloat(totais.vendas_do_dia) /
                          totais.pedidos_finalizados
                        ).toLocaleString("pt-br", { minimumFractionDigits: 2 })}
                      </strong>
                    </p>
                  </div>
                </th>
                <th>
                  <div>
                    <p>
                      TOTAL DE VENDA
                      <br />
                      RS{" "}
                      <strong>
                        {parseFloat(totais.vendas_do_dia).toLocaleString(
                          "pt-br",
                          { minimumFractionDigits: 2 }
                        )}
                      </strong>
                    </p>
                  </div>
                </th>
              </tfoot>
            </table>
          </ContentGridTable>
        </ContentGrid>
      </>
    );
  }
}

export default ProdutividadeDetalhada;
